import { expr } from "jquery";

/*Sections*/
export const PSectionInsuranceRequests = "insurance-requests";
export const PSectionReports = "reports-section";
export const PSectionAgencies = "agencies";
export const PSectionExpenses = "expenses";
export const PSectionBalanceRequests = "balance-requests";
export const PSectionAgencyLists = "agency-lists";
export const PSectionDebtSendingSchedules = "debtsending-schedules";
export const PSectionAnnouncements = "announcements";
export const PSectionResidenceAppointments = "residence-appointments";
export const PSectionBulkRatiosRequests = "bulk-ratios-requests";
export const PSectionLeads = "leads";
export const PSectionFinancialRequests = "financial-requests";
export const PSectionProfits = "profits";
export const PSectionInsuranceCompanies = "insurance-companies";
export const PSectionUsers = "users";
export const PSectionInvoices = "invoices";
export const PSectionSources = "sources";
export const PSectionServices = "services";
export const PSectionServiceNames = "service-names";
export const PSectionCustomers = "customers";
export const PSectionPayments = "payments";
export const PSectionPaymentMethods = "payment-methods";
export const PSectionMoneyAccounts = "money-accounts";
export const PSectionWhatsapp = "whatsapp";
export const PSectionWhatsappDevices = "whatsapp-devices";
export const PSectionSmsMessages = "sms-messages";
/*Permissions*/
export const PermissionDiscount = "override-ratio";
export const PermissionAgenciesModify = "modify";
export const PermissionAgenciesCreate = "create";
export const PermissionAgenciesViewMainPageAll = "view-main-page-all";
export const PermissionAgenciesDeactivate = "deactivate";
export const PermissionAgenciesDelete = "delete";
export const PermissionAgenciesChangeRatios = "change-ratios";
export const PermissionAgenciesSendRatiosToAgency = "send-ratios-to-agency";
export const PermissionAgenciesForceAgencyLogout = "force-agency-logout";
export const PermissionAgenciesSendFinancialActivityFile =
  "send-financial-activity-file";
export const PermissionAgenciesExportInsurancesCountByDuration =
  "export-insurances-count-by-duration";
export const PermissionAgenciesViewRatioHistory = "view-ratio-history";

export const PermissionAgenciesListsViewAll = "view-all";
export const PermissionAgenciesListsCreate = "create";
export const PermissionAgenciesListsModify = "modify";
export const PermissionAgenciesListsDelete = "delete";
export const PermissionAgenciesExportAgencies = "export-agencies";

export const PermissionBalanceRequestsCreate = "create";
export const PermissionBalanceRequestsTriggerAutoApprove =
  "trigger-auto-approve-by-time";
export const PermissionInsuranceRequestsApprove = "approve";
export const PermissionInsuranceRequestsDecline = "decline";
export const PermissionInsuranceRequestsToggleLock = "toggle-lock";
export const PermissionInsuranceRequestsChangeToWaitingPrice =
  "change-status-to-waiting-price";
export const PermissionInsuranceRequestsRequestSecondYear =
  "request-second-year-insurance-request";
export const PermissionInsuranceRequestsRetryAll = "retry-all";
export const PermissionInsuranceRequestsShowCreatedByName =
  "show-created-by-name";
export const PermissionInsuranceRequestsModifyDate = "modify-date";
export const PermissionInsuranceRequestsHide = "hide";
export const PermissionInsuranceRequestsMove = "move";
export const PermissionInsuranceRequestsReplaceFiles = "replace-files";
export const PermissionInsuranceRequestsResendFile = "resend-file";
export const PermissionInsuranceRequestsChangeCountry = "change-country";
export const PermissionInsuranceRequestsChangeDaskInfo = "change-dask-info";
export const PermissionInsuranceRequestsTryFetchFile = "try-fetching-file";
export const PermissionInsuranceRequestsForceIfDuplicated =
  "force-if-duplicated";
export const PermissionInsuranceRequestsForceAsDebt = "force-as-debt";
export const PermissionInsuranceRequestsMovePriceSet = "move-price-set";
export const PermissionInsuranceRequestsShowCountryColumn =
  "show-country-column";
export const PermissionInsuranceRequestsChangeSponsorInfo =
  "change-sponsor-info";

export const PermissionInvoicesViewAll = "view-all";
export const PermissionInvoicesCreate = "create";
export const PermissionInvoicesModify = "modify";

export const PermissionBalanceRequestsMove = "move";
export const PermissionBalanceRequestsClaimDebtByParentAgencyProfit =
  "claim-debt-by-parent-agency-profit";

export const PermissionUsersForceUserLogout = "force-user-logout";
export const PermissionUsersSendNewCredentialsToUser =
  "send-new-credentials-to-user";

export const PermissionDebtSendingSchedulesCreate = "create";
export const PermissionDebtSendingSchedulesViewAll = "view-all";

export const PermissionSourcesViewAll = "view-all";
export const PermissionSourcesCreate = "create";
export const PermissionSourcesModify = "modify";
export const PermissionSourcesDelete = "delete";

export const PermissionServicesViewAll = "view-all";
export const PermissionServicesCreate = "create";
export const PermissionServicesModify = "modify";
export const PermissionServicesDelete = "delete";

export const PermissionReportAgencyActivity = "agency-activity";
export const PermissionReportDiscountRates = "discount-rates-report";
export const PermissionReportAdvancedReports = "advanced-reports";
export const PermissionReportInsuranceCompanies = "insurance-companies";
export const PermissionReportInsurancesComparison = "insurances-comparison";
export const PermissionReportAgenciesHasDebt = "agencies-who-has-debt";
export const PermissionAgenciesSendByWhatsApp = "send-by-whatsapp";

export const PermissionMoneyAccountsViewAll = "view-all";
export const PermissionMoneyAccountsTransactions = "view-transactions";

export const PermissionUsersCanViewAllUsersLoggedDevices =
  "can-view-all-users-logged-devices";

export const PermissionMoneyTransactionsTransferBetweenAccounts =
  "transfer-from-to-account";

export const PermissionSMSMessagesViewAll = "view-all";

//whatsapp devices permissions
export const PermissionWhatsappDevicesViewAll = "view-all";
export const PermissionWhatsappDevicesCreate = "create";
export const PermissionWhatsappDevicesModify = "modify";
export const PermissionWhatsappDevicesDelete = "delete";
export const PermissionWhatsappDevicesConnect = "connect";
export const PermissionWhatsappDevicesToggleAvailability =
  "toggle-availability";
export const PermissionWhatsappDevicesCanViewAllSystemDevices =
  "can-view-all-system-devices";
export const PermissionWhatsappDevicesCanOpenChat = "can-open-chat";
export const PermissionWhatsappDevicesDownloadRawChat = "download-raw-chat";
export const PermissionWhatsappDevicesDownloadRawContacts =
  "download-raw-contacts";
export const PermissionWhatsappDevicesCheckContacts = "check-contacts";
export const PermissionWhatsappDevicesGetChatByContact = "get-chat-by-contact";

export const PSectionSettings = "settings";
export const PermissionSettingsViewBankInfo = "view-bank-info";
export const PermissionSettingsModifyBankInfo = "modify-bank-info";
export const PermissionsFinancialRequestsViewBillingProfileReport =
  "billing-profile-report";
